import script from "./AddApprovedVersionModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddApprovedVersionModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddApprovedVersionModal.vue?vue&type=style&index=0&id=2dda3ebe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dda3ebe"]])

export default __exports__